import React from 'react';
import PropTypes from 'prop-types';

const FooterLogo = (props) => {
    const {url, imgSrc} = props;
    return (
        <ul className="logo-container">
            <li className="logo-inner-container">
                <a
                    className="logo-redirection-link"
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        className="logo-image"
                        aria-label="Opens in a new window"
                        src={imgSrc}
                        alt="Vrbo"
                        width="100%"
                        loading="lazy"
                    />
                </a>
            </li>
        </ul>
    );
};

FooterLogo.propTypes = {
    url: PropTypes.string.isRequired,
    imgSrc: PropTypes.string.isRequired,
};

export default FooterLogo;
